export default __webpack_public_path__ + "static/media/sv_16.dbc79322.webp";